import { Handle, Position } from 'reactflow';
import { memo, useContext, useMemo } from 'react';
import { WorkflowContext } from 'providers/workflow-provider';
import Images from 'assets/Images';
import { getValueById } from 'utils';
import { useSelector } from 'react-redux';
import './style.scss';
import { HelpIcon } from 'components/generic';

const DelayNode = ({ id, data }) => {
	const context = useContext(WorkflowContext);
	const { addNode, setNodeConfigureIndex, edges, dockerState, handleComponentClick, handleDeleteNode } = context;
	const { referenceData } = useSelector(state => ({ referenceData: state?.referenceData?.data }));

	const timeUnitsList = useMemo(() => getValueById(referenceData, 'rd_timeUnits')?.value, [referenceData]);

	const edgeExists = useMemo(() => edges.some(el => el?.source === id), [edges]);

	const handleAdd = () => {
		dockerState !== 'view' && addNode({ id, data });
	};

	const handleSidebar = () => {
		setNodeConfigureIndex(+id);
		handleComponentClick('delay');
	};

	return (
		<div className='header-node'>
			<div className='header-node__header space-between'>
				<div className='display-flex align-center'>
					<h6>Delay</h6>
					<HelpIcon infoContent='Delay block waits for time period specified to go for next node' />
				</div>
				<div className='display-flex'>
					<img className='header-node__edit' src={Images['edit-blue']} alt='Edit' onClick={handleSidebar} height='15px' width='15px' />
					{!edgeExists && <img src={Images.deleteBlue} alt='Edit' onClick={() => handleDeleteNode(id)} height='15px' width='15px' />}
				</div>
			</div>
			<div className='header-node__description'>
				<Handle type='target' position={Position.Top} id={`top-${id}`} />
				<span>{!data?.duration?.period || !data?.duration?.value ? 'Configuring....' : `Wait for ${data?.duration?.value} ${getValueById(timeUnitsList, data?.duration?.period)?.value || '-'}`}</span>
			</div>
			<Handle type='source' position={Position.Bottom} id={`bottom-${id}`} />
			{!edgeExists && <img className='header-node__add' src={Images?.add} alt='Add' onClick={handleAdd} />}
		</div>
	);
};

export default memo(DelayNode);
